import { getStoryblokApi } from "@storyblok/react";

export const getStoryblokStory = async (slug, params) => {
  const res = await getStoryblokApi()?.get(`cdn/stories/${slug}`, params);
  return res?.data;
};
